'use client';

import { Popover, PopoverContent, PopoverTrigger } from '@shared/components/shadcn';
import { twMerge } from '@shared/themes';
import { useState } from 'react';

type IconWithTooltipProps = {
  className?: string;
  tooltipContent: string;
  children: React.ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  align?: 'start' | 'center' | 'end';
  sideOffset?: number;
  ariaLabel?: string;
};

function IconWithTooltip({ tooltipContent, children, className, side = 'top', align = 'center', sideOffset = 4, ariaLabel = 'More information', ...props }: IconWithTooltipProps) {
  const [open, setOpen] = useState(false);

  const handleMouseEnter = () => {
    setOpen(true);
  };

  const handleMouseLeave = () => {
    setOpen(false);
  };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} aria-label={ariaLabel}>
        {children}
      </PopoverTrigger>
      <PopoverContent
        className={twMerge('bg-container-base p-xs paragraph-s w-[90vw] sm:w-fit sm:max-w-90', className)}
        side={side}
        align={align}
        sideOffset={sideOffset}
        avoidCollisions={true}
        collisionPadding={10}
        {...props}
      >
        {tooltipContent}
      </PopoverContent>
    </Popover>
  );
}

export { IconWithTooltip };
